module.exports = __webpack_public_path__ + "SourceSansPro-Light.a4bf3e4194dcf649cb7b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Light.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Light.eot
// module chunks = styles